import io from 'socket.io-client';
import { API_BASE_URL } from '../config/api';

// Extract domain from API_BASE_URL for socket connection
// Assuming API_BASE_URL is like 'https://apilords.codefactory.games/api'
// We want 'https://apilords.codefactory.games'
// Extract domain from API_BASE_URL for socket connection
// Use URL object to gracefully handle various URL formats (with/without path, etc.)
let SOCKET_URL = '';
try {
  const urlObj = new URL(API_BASE_URL);
  SOCKET_URL = urlObj.origin;
} catch (e) {
  console.error("Invalid API_BASE_URL:", API_BASE_URL);
  // Fallback or leave empty to fail gracefull
  SOCKET_URL = API_BASE_URL.replace('/api', '');
}

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect(token) {
    if (this.socket) return;

    console.log('[SocketService] Connecting to', SOCKET_URL);

    this.socket = io(SOCKET_URL, {
      auth: { token },
      transports: ['polling', 'websocket'],
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    this.socket.on('connect', () => {
      console.log('[SocketService] Connected:', this.socket.id);
    });

    this.socket.on('connect_error', (err) => {
      console.error('[SocketService] Connection Error:', err.message);
    });

    this.socket.on('disconnect', (reason) => {
      console.log('[SocketService] Disconnected:', reason);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  // Force logout (single-session enforcement)
  onForceLogout(callback) {
    if (!this.socket) return;

    this.socket.off('force-logout');

    this.socket.on('force-logout', (data) => {
      console.log('[SocketService] Force logout received:', data?.reason || 'session replaced');
      callback(data);
    });

    return () => {
      if (this.socket) this.socket.off('force-logout');
    };
  }

  // Admin Profile
  subscribeToAdminProfile(token, callback) {
    if (!this.socket) return;

    // Remove existing listener if any to prevent duplicates
    this.socket.off('adminProfileUpdate');

    this.socket.on('adminProfileUpdate', (data) => {
      // console.log('[SocketService] adminProfileUpdate:', data);
      callback(data);
    });

    this.socket.emit('getAdminProfile', { token });

    return () => {
      if (this.socket) this.socket.off('adminProfileUpdate');
    };
  }

  // User List (Agent Listing)
  subscribeToUsersAllDetails(params, token, callback) {
    if (!this.socket) return;

    this.socket.off('usersAllDetailsUpdate');

    this.socket.on('usersAllDetailsUpdate', (data) => {
      // console.log('[SocketService] usersAllDetailsUpdate received');
      callback(data);
    });

    // Emit initial request with params
    this.emitGetUsersAllDetails(params, token);

    return () => {
      if (this.socket) {
        this.socket.off('usersAllDetailsUpdate');
        this.socket.emit('stopUsersAllDetails');
      }
    };
  }

  emitGetUsersAllDetails(params, token) {
    if (!this.socket) return;
    // console.log('[SocketService] Emitting getUsersAllDetails', params);
    this.socket.emit('getUsersAllDetails', { ...params, token });
  }
}

export const socketService = new SocketService();
